var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParcelCenter = function SvgParcelCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 22,
    r: 12,
    fill: "#00C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005269",
    d: "M10.182 27.11l2.204 2.002-7.494 8.155-2.204-2.001 7.494-8.157zm3.145.154l1.148 1.044a1 1 0 0 1 .064 1.416l-8.847 9.628a1 1 0 0 1-1.409.064L.598 36.07a1 1 0 0 1-.064-1.417l8.848-9.63a1 1 0 0 1 1.409-.063l1.066.97c.033-.047.07-.091.112-.132l2.874-2.86a12.942 12.942 0 0 1-4.33-9.668C10.513 6.086 16.37.264 23.59.264c7.221 0 13.077 5.822 13.077 13.006S30.811 26.276 23.59 26.276c-2.636 0-5.09-.776-7.144-2.111l-3.067 3.05a1.015 1.015 0 0 1-.052.05zm-.814-13.994c0 6.077 4.959 11.006 11.077 11.006 6.12 0 11.077-4.93 11.077-11.006 0-6.077-4.958-11.006-11.077-11.006-6.118 0-11.077 4.93-11.077 11.006zm10.858-7.962a1 1 0 0 1 0 2c-3.339 0-6.043 2.689-6.043 6.003a1 1 0 1 1-2 0c0-4.421 3.602-8.003 8.043-8.003z"
  })))));
};
export default SvgParcelCenter;